import { CampaignStatusSchema as i, AdGroupIdSchema as b, CampaignIdSchema as s, SingleDimensionInputSchema as F, SingleDimensionOutputSchema as _, CampaignDealTypeSchema as M, PercentSchema as S, CpaAutoRuleIdSchema as H, UserIdSchema as U, CreativeGroupIdSchema as u, TargetGroupIdSchema as y, DateTimeSchema as m, BidSchema as C, OnOffSchema as k, CampaignGroupIdSchema as V, TrafficLimitSchema as R, BudgetLimitInputSchema as I, PricingRuleModelSchema as N, DeliverySchema as q, isInputDimension as z, SingleStartStopDimensionInputSchema as W, StoredBudgetLimitSchema as D } from "@hprofits/shared";
import { CpaAutoRulesExclusionsSchema as X } from "@hprofits/shared/dimensions";
import { optional as v } from "@hprofits/utils/fp/optional";
import { z as e } from "zod";
import { API_VIEW as A } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import "../common/owner.js";
import "../common/params.js";
const Q = e.partialRecord(
  i.exclude([i.enum.Hidden]),
  e.number().int().nonnegative()
), $ = e.object({
  id: b,
  name: e.string(),
  detailedStatus: Q
}).readonly(), Pe = e.array($).readonly(), L = (t) => e.object({
  id: t,
  name: e.string().trim().min(1, "name must be non-empty").max(30),
  selected: e.boolean()
}).readonly(), Ce = L(y), Ae = L(u), w = e.enum(["calculated", "shared"]), J = e.enum(["manual", "auto"]), o = (t) => e.object({
  modifier: J,
  value: t
}).readonly(), l = (t, n) => !!(t && n && t.value > n.value), d = e.object({
  delivery: o(q),
  pricingModel: o(N),
  bid: o(C),
  budgetLimitOverall: o(I).optional(),
  budgetLimitDaily: o(I).optional(),
  trafficLimitOverall: o(R).optional(),
  trafficLimitDaily: o(R).optional(),
  cappingImpressions: o(e.int().nonnegative()).optional(),
  cappingFrequency: o(e.int().nonnegative()).optional()
}), Le = e.object({
  forceDeleteIds: e.array(s).readonly().optional()
}), O = {
  budgetLimitOverall: o(D).optional(),
  budgetLimitDaily: o(D).optional()
}, P = 30, K = d.partial().extend({
  id: s.optional(),
  parentId: s.optional(),
  dimension: F.optional()
}), h = (t) => z(t, W), G = (t, n) => {
  if (!t || t.length === 0)
    return;
  const r = t.filter((a) => a.dimension !== "other");
  if (r.length === 0)
    return;
  const c = r.some((a) => h(a.dimension)), g = r.some((a) => a.dimension && !h(a.dimension));
  c && g && n.addIssue("Sub-rules at one level must all be time-based or all be dimension-based");
}, j = e.strictObject({
  ...K.shape,
  get subRules() {
    return e.array(j).optional();
  }
}).superRefine((t, n) => {
  if (t.dimension || n.addIssue("Sub-rule dimension is required"), l(t.budgetLimitDaily, t.budgetLimitOverall) && n.addIssue("Daily budget limit must be less than overall limit"), l(t.trafficLimitDaily, t.trafficLimitOverall) && n.addIssue("Daily traffic limit must be less than overall limit"), t.dimension && t.dimension !== "other" && !h(t.dimension)) {
    const r = t.dimension, c = [
      "domains",
      "spots",
      "geo",
      "languages",
      "browsers",
      "devices",
      "os",
      "ips",
      "keywords",
      "categories",
      "contentTypes"
    ];
    for (const g of c) {
      const a = r[g];
      if (a && typeof a == "object" && "type" in a && a.type === "exclude") {
        n.addIssue("Exclude dimensions are not allowed in sub-rules");
        break;
      }
    }
  }
  G(t.subRules, n);
}), Y = d.extend({
  ...O,
  id: s,
  parentId: s,
  status: i,
  statusChangeReason: e.string().optional(),
  dimension: _.optional(),
  /**
   * The target group blocks this sub-rule's dimension, so it can never buy.
   * Derived on read from the rule's target group — output only, never accepted
   * on input, and never persisted.
   */
  targetConflict: e.boolean()
}), f = Y.extend({
  get subRules() {
    return e.array(f).readonly().optional();
  }
}), x = (t) => d.extend({
  ...O,
  id: s,
  mode: w,
  targetGroupId: y,
  creativeGroupId: u,
  status: i,
  statusChangeReason: e.string().optional(),
  startDate: m.optional(),
  endDate: m.optional(),
  subRules: e.array(t)
}).readonly(), Z = 1e3, ee = 4, te = e.number().positive().max(Z).multipleOf(10 ** -ee), B = e.object({
  priority: M,
  resellFeePercent: S.optional(),
  directFeePercent: S.optional(),
  autoRotateIsEnabled: e.boolean(),
  feedUrl: e.url().optional(),
  // todo: support this feature ?
  cpaAutoRuleIds: e.array(H).refine((t) => new Set(t).size === t.length, { error: "cpaAutoRuleIds must not contain duplicate ids" }).readonly().optional(),
  trainingPercent: S.optional(),
  cpaCoef: te.optional()
}).readonly(), ne = B.unwrap().extend({
  ownerId: U,
  cpaAutoRulesExclusions: X.optional()
}).readonly(), E = d.extend({
  id: s.optional(),
  mode: w,
  targetGroupId: y,
  creativeGroupId: u,
  startDate: m.optional(),
  endDate: m.optional(),
  subRules: e.array(j)
}).strict(), ie = (t, n) => !!(t && n && n < t), ae = (t) => !!(t && new Date(t) < /* @__PURE__ */ new Date()), T = (t, n) => {
  const r = v(t.startDate), c = v(t.endDate);
  ie(r, c) && n.addIssue("End date must be after start date!"), ae(c) && n.addIssue("End date cannot be in the past!"), l(t.budgetLimitDaily, t.budgetLimitOverall) && n.addIssue("Daily budget limit must be less than overall limit"), l(t.trafficLimitDaily, t.trafficLimitOverall) && n.addIssue("Daily traffic limit must be less than overall limit"), G(t.subRules, n);
}, oe = E.superRefine(T).readonly(), re = E.extend(B.unwrap().shape).superRefine(T).readonly(), we = e.union([oe, re]), se = e.object({
  oldStatus: i,
  newStatus: i.exclude([
    i.enum.Hidden,
    i.enum.Active,
    i.enum.Rejected
  ])
}).strict().readonly(), ce = e.object({
  oldStatus: i,
  newStatus: i.exclude([
    i.enum.Hidden,
    i.enum.Active,
    i.enum.Rejected
  ]),
  reason: e.string().min(1).optional()
}).strict().readonly(), Oe = e.union([
  se,
  ce
]), Ge = e.object({
  bid: e.coerce.number().pipe(C)
}).readonly(), je = e.object({
  minCpm: e.number(),
  maxCpm: e.number(),
  prediction: e.number()
}).readonly(), me = x(f).unwrap().extend({
  view: e.literal(A.common)
}).readonly(), le = x(f).unwrap().extend({
  ...ne.unwrap().shape,
  view: e.literal(A.admin)
}).readonly(), ue = e.discriminatedUnion("view", [
  me,
  le
]), p = e.object({
  name: e.string().trim().min(1, "name must be non-empty").max(P, `name must be at most ${P} characters`),
  status: k
}).strict().readonly(), xe = e.object({
  sourceId: b,
  name: p.unwrap().shape.name,
  creativeGroupId: u
}).strict().readonly(), Be = p.unwrap().pick({ status: !0 }).strict().readonly(), Ee = e.object({
  name: p.unwrap().shape.name
}).strict().readonly(), Te = p.unwrap().extend({
  id: b,
  campaignId: V,
  pricingRules: e.array(ue).readonly()
}).readonly();
export {
  P as AD_GROUP_NAME_MAX_LENGTH,
  Pe as AdGroupListSchema,
  $ as AdGroupListViewSchema,
  Te as AdGroupSchema,
  ee as CPA_COEF_DECIMAL_PLACES,
  Z as CPA_COEF_MAX,
  xe as CopyAdGroupSchema,
  te as CpaCoefSchema,
  p as CreateAdGroupSchema,
  Ae as CreativeGroupReferenceSchema,
  J as LimitFieldModifierSchema,
  re as PricingRuleAdminInputSchema,
  le as PricingRuleAdminViewSchema,
  B as PricingRuleAdminWritableFieldsSchema,
  Ge as PricingRuleBidRangeQuerySchema,
  je as PricingRuleBidRangeSchema,
  oe as PricingRuleCommonInputSchema,
  me as PricingRuleCommonViewSchema,
  Le as PricingRuleForcedDeletionsSchema,
  we as PricingRuleInputSchema,
  w as PricingRuleModeSchema,
  ne as PricingRuleOutputAdminFieldsSchema,
  ue as PricingRuleOutputSchema,
  Q as PricingRuleSetDetailedStatusSchema,
  d as PricingRuleSettingsSchema,
  ce as PricingRuleStatusChangeAdminSchema,
  se as PricingRuleStatusChangeCommonSchema,
  Oe as PricingRuleStatusChangeSchema,
  Ee as RenameAdGroupSchema,
  K as SubTargetPricingRuleInputBaseSchema,
  j as SubTargetPricingRuleInputSchema,
  Y as SubTargetPricingRuleOutputBaseSchema,
  f as SubTargetPricingRuleOutputSchema,
  Ce as TargetGroupReferenceSchema,
  Be as UpdateAdGroupSchema,
  L as createNamedReferenceSchema,
  l as hasDailyLimitAboveOverall
};
//# sourceMappingURL=schemas.js.map
